/**
 * Setting up an account from an invite — the steps, named once (Aaron, step 27).
 *
 * "It's going through the stages, but none are indicated on the initial
 * password screen." The stages were real — a password on `/set-password`,
 * then two-step and a crew PIN on `/set-up` — but only the second page drew
 * them, and it numbered them from an invite the person never saw ("step 3 of
 * 4"). So the list is here: the password page asks the server for it before
 * there is a session (`POST /auth/set-password/about`), `/set-up` works it out
 * from `/me`, and both draw the same named stages from the same function.
 */
import { z } from 'zod';
export const SETUP_STEPS = ['password', 'mfa', 'pin'];
/** What each stage is called above the bar. */
export const SETUP_STEP_LABELS = {
    password: 'Password',
    mfa: 'Two-step sign-in',
    pin: 'Crew PIN',
};
/**
 * What is still owed after the password, in the order it is asked for.
 *
 * Two-step when a role requires it and the person holds no method yet — an
 * address that already signs in somewhere else with a passkey has nothing to
 * set up here. A PIN when a role opens the crew app and there is none.
 */
export function stepsAfterPassword(facts) {
    const steps = [];
    if (facts.mfaRequired && !facts.mfaEnrolled)
        steps.push('mfa');
    if (facts.pinExpected && !facts.hasPin)
        steps.push('pin');
    return steps;
}
export const setPasswordAboutRequest = z.object({ token: z.string().min(32) });
//# sourceMappingURL=account-setup.js.map